import { useEffect, useRef, useState } from 'react';

//https://mui.com/x/react-data-grid/sorting/#multi-sorting
const ColumnFilterBar = (props) => {
    const { columns, bar, removeBar, onChange = () => {} } = props;
    const selectAndOr = useRef();
    const selectField = useRef();
    const selectMatch = useRef();
    const inputFieldValue = useRef();
    const [fieldIsNumeric, setFieldIsNumeric] = useState(false);
    const [filterBarVisible, setFilterBarVisible] = useState(true);
    const updateBarValues = () => {
        const allowTextInput = selectMatch.current.value !== 'isEmpty' && selectMatch.current.value !== 'isNotEmpty';
        setFilterBarVisible(allowTextInput);
        setFieldIsNumeric(selectField.current.value === 'Published Year');
        onChange({
            time: bar.time,
            id: bar.id,
            andOr: selectAndOr.current.value,
            field: selectField.current.value,
            matchCondition: selectMatch.current.value,
            value: inputFieldValue.current.value
        });
    };
    return (
        <div id={'bar-' + bar.id} className="filter-bar">
            {bar.id > 0 && (
                <>
                    <button className="removeBar" onClick={() => removeBar(bar.id)}>
                        <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall css-1k33q06" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="CloseIcon">
                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                        </svg>
                    </button>

                    <div className="logical-condition">
                        <select ref={selectAndOr} onChange={updateBarValues}>
                            <option>And</option>
                            <option>Or</option>
                        </select>
                    </div>
                </>
            )}
            {bar.id === 0 && (
                <div className="spacer">
                    <input type="hidden" ref={selectAndOr} value="And"></input>
                </div>
            )}
            <div className="field-select">
                <select ref={selectField} onChange={updateBarValues}>
                    <option value="">Select</option>
                    {columns &&
                        columns
                            .filter((c) => !c.hasOwnProperty('hide'))
                            .map((c, i) => {
                                return (
                                    <option key={i} value={c.field}>
                                        {c.headerName}
                                    </option>
                                );
                            })}
                </select>
            </div>
            <div className="match-condition">
                <select ref={selectMatch} onChange={updateBarValues}>
                    <option value="contains">Contains</option>
                    <option value="=">=</option>
                    <option value="!=">!=</option>
                    {fieldIsNumeric && (
                        <>
                            <option value=">">&gt;</option>
                            <option value=">=">&gt;=</option>
                            <option value="<">&lt;</option>
                            <option value="<=">&lt;=</option>
                        </>
                    )}

                    <option value="isEmpty">is empty</option>
                    <option value="isNotEmpty">is not empty</option>
                </select>
            </div>
            <div>
                <input id="filterValue" ref={inputFieldValue} onChange={updateBarValues} style={{ display: filterBarVisible ? 'block' : 'none' }} value={bar.value}></input>
            </div>
        </div>
    );
};

const TableFilterBar = (props) => {
    const { columns, visible, onChange = () => {} } = props;
    const [bars, setBars] = useState([{ id: 0, time: new Date().getTime() }]);
    const findHighestId = () =>
        bars.reduce(
            (highID, bar) => {
                return Math.max(highID, bar.id);
            },
            [0]
        );
    const addBar = () => {
        setBars([...bars, { id: findHighestId() + 1, time: new Date().getTime() }]);
    };
    const removeBar = (id) => {
        var fBars = bars.filter((b) => b.id !== id);
        setBars(fBars);
        onChange(barsToConditions(fBars));
    };
    const removeAllBar = () => {
        setBars([{ id: 0, time: new Date().getTime() }]);
        onChange([]);
    };
    const barsToConditions = (bars) => {
        return bars.filter((b) => {
            return b.field && b.hasOwnProperty('value');
        });
    };
    const onFilterChange = (row) => {
        var ind = bars.findIndex((bar) => bar.id === row.id);
        var clonedBars = [...bars];
        clonedBars[ind] = row;
        setBars(clonedBars);
        onChange(barsToConditions(clonedBars));
    };

    return (
        <div className={'filter-toolbar' + (visible ? ' on' : '')}>
            {bars.map((bar) => {
                return <ColumnFilterBar key={bar.time} bar={bar} columns={columns} removeBar={removeBar} onChange={onFilterChange} />;
            })}
            <div className="filter-btn-controls">
                <span className="MuiButton-label add-filter-btn" onClick={addBar}>
                    <span className="MuiButton-startIcon MuiButton-iconSizeMedium">
                        <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path>
                        </svg>
                    </span>
                    Add filter
                </span>
                <span className="MuiButton-label clearAll" onClick={() => removeAllBar()}>
                    <span className="MuiButton-startIcon MuiButton-iconSizeMedium">
                        <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="DeleteIcon">
                            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"></path>
                        </svg>
                    </span>
                    Remove All
                </span>
            </div>
        </div>
    );
};

export default TableFilterBar;
